<template>
  <div>
    <add-note-dialog
      ref="addNoteDialog"
    />
    <add-payment-dialog
      ref="addPaymentDialog"
      @onInsert="FetchItems"
    />
    <bookings-edit
      ref="bookingsEdit"
      v-model="isEditSidebarActive"
      @refetch-data="FetchItems"
    />
    <add-add-ons-dialog
      ref="addAddOnsDialog"
    />
    <full-view-dialog
      ref="fullViewDialog"
    />
    <!-- list filters -->
    <v-card>
      <v-card-title class="pb-0 pt-2">
        Filtros
        <v-spacer></v-spacer>
        <!-- Search -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="me-3"
              icon
              v-bind="attrs"
              @click="Search"
              v-on="on"
            >
              <v-icon size="18">
                {{ icons.mdiMagnify }}
              </v-icon>
            </v-btn>
          </template>
          <span>Buscar</span>
        </v-tooltip>
        <!-- Clear Search -->
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              class="me-3"
              icon
              v-bind="attrs"
              v-on="on"
              @click="ClearSearch"
            >
              <v-icon size="18">
                {{ icons.mdiBackspaceOutline }}
              </v-icon>
            </v-btn>
          </template>
          <span>Limpiar Búsqueda</span>
        </v-tooltip>
      </v-card-title>
      <v-row class="px-2 ma-0">
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            v-model="searchQuery"
            single-line
            dense
            outlined
            hide-details
            placeholder="Email, Cliente, Teléfono, Locación o Meta"
            @keyup.enter="Search"
          ></v-text-field>
        </v-col>
        <!-- Event filter -->
        <v-col
          cols="12"
          sm="4"
        >
          <event-select
            ref="eventSelect"
            @onSelect="SelectedEvent"
          >
          </event-select>
        </v-col>

        <!-- Event Status Filter -->
        <v-col
          cols="12"
          sm="4"
        >
          <event-status-multiselect
            ref="eventStatusSelect"
            v-model="selectedEventStatus"
            :default="[1,2,3,4]"
            clearable
          >
          </event-status-multiselect>
        </v-col>

        <!-- Payment Status Filter -->
        <v-col
          cols="12"
          sm="4"
        >
          <payment-status-multiselect
            ref="paymentStatusSelect"
            v-model="selectedPaymentStatus"
            clearable
          >
          </payment-status-multiselect>
        </v-col>

        <!-- Date Filters-->
        <v-col
          cols="12"
          sm="4"
        >
          <range-date-picker
            ref="rangeDatePicker"
            :default-from="defaultFromDate"
            :default-to="defaultToDate"
            clearable
            @selectedFrom="SelectedFromFilter"
            @selectedTo="SelectedToFilter"
          ></range-date-picker>
        </v-col>
      </v-row>
    </v-card>

    <v-divider class="mt-4"></v-divider>

    <!-- DATA CARD-->
    <v-card>
      <v-card-text class="d-flex align-center flex-wrap pb-0">
        <div class="d-flex align-center pb-5">
          <h1>Citas Registradas</h1>
        </div>
      </v-card-text>

      <!-- table -->
      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        class="text-no-wrap"
      >
        <!-- actions -->
        <template #[`item.actions`]="{ item }">
          <div class="d-flex align-center justify-center">
            <!-- Edit  -->
            <table-action-button
              :icon="icons.mdiPencilOutline"
              text="Editar"
              @OnClick="ShowEditDialog(item)"
            />
            <!-- Add Payment  -->
            <table-action-button
              :icon="icons.mdiCashRegister "
              text="Agregar Pago"
              @OnClick="addPaymentDialog.ShowDialog(item)"
            />
            <!-- Add Note  -->
            <table-action-button
              :icon="icons.mdiNotePlusOutline"
              text="Agregar Nota"
              @OnClick="addNoteDialog.ShowDialog(item)"
            />
            <!-- Add AddOns  -->
            <table-action-button
              :icon="icons.mdiCartPlus "
              text="Agregar AddOns"
              @OnClick="addAddOnsDialog.ShowDialog(item)"
            />
            <!-- view  -->
            <table-action-button
              :icon="icons.mdiEye"
              text="Ver Cita"
              @OnClick="fullViewDialog.ShowDialog(item.bookingKey)"
            />
          </div>
        </template>
        <!-- Start - End dates -->
        <template #[`item.startDate`]="{ item }">
          <span :inner-html.prop="item.startDate | datediff(item.endDate)"></span>
        </template>
        <!-- CreationDate -->
        <template #[`item.createdOn`]="{ item }">
          {{ item.createdOn | date }}
        </template>
        <!-- Price -->
        <template #[`item.price`]="{ item }">
          {{ item.price | currency }}
        </template>
        <!-- Statuses -->
        <template #[`item.eventStatusId`]="{ item }">
          <eventStatus :status="item.eventStatusId" />
        </template>
        <template #[`item.payStatusId`]="{ item }">
          <paymentStatus :status="item.payStatusId" />
        </template>
        <template
          #[`item.bookingId`]="{ item }"
        >
          <v-btn
            text
            small
            @click="fullViewDialog.ShowDialog(item.bookingKey)"
          >
            {{ item.bookingId }}
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import {
  mdiDeleteOutline, mdiEye, mdiMagnify, mdiBackspaceOutline, mdiPencilOutline,
  mdiCashRegister, mdiNotePlusOutline, mdiCartPlus,
} from '@mdi/js'

// composition function
import {
  ref, watch, onMounted, onUnmounted,
} from '@vue/composition-api'
import store from '@/store'
import eventStatus from '@/components/statusIcon/EventStatus.vue'
import paymentStatus from '@/components/statusIcon/PaymentStatus.vue'
import BookingsEdit from './BookingsEdit.vue'
import { active, activeColor } from '@/scripts/helpers/constants'
import RangeDatePicker from '@/components/datepicker/RangeDatePicker.vue'
import EventSelect from '@/components/selects/EventSelect.vue'
import EventStatusMultiselect from '@/components/selects/EventStatusMultiselect.vue'
import PaymentStatusMultiselect from '@/components/selects/PaymentStatusMultiselect.vue'
import AddPaymentDialog from '@/views/payments/components/AddPaymentDialog.vue'
import TableActionButton from '@/components/controls/TableActionButton.vue'
import AddNoteDialog from '@/views/notes/components/AddNoteDialog.vue'
import AddAddOnsDialog from '@/views/addOns/components/AddAddOnsDialog.vue'
import FullViewDialog from './components/FullViewDialog.vue'
import daysFromToday from '@/scripts/helpers/daysFromToday'

export default {
  components: {
    eventStatus,
    paymentStatus,
    RangeDatePicker,
    BookingsEdit,
    EventSelect,
    EventStatusMultiselect,
    PaymentStatusMultiselect,
    AddPaymentDialog,
    TableActionButton,
    AddNoteDialog,
    AddAddOnsDialog,
    FullViewDialog,
  },
  setup() {
    const bookingsEdit = ref()

    const ShowEditDialog = item => {
      bookingsEdit.value.ShowEditDialog(item.bookingKey)
    }

    const items = ref([])

    // Table Handlers
    const headers = [
      { text: '#ID', align: 'start', value: 'bookingId' },
      { text: 'Cliente', value: 'client' },
      { text: 'Servicio', value: 'event' },
      { text: 'Fecha', value: 'startDate' },
      { text: '', value: 'eventStatusId' },
      { text: '', value: 'payStatusId' },
      { text: 'Precio', value: 'price' },
      { text: 'Vend.', value: 'salesPerson' },
      { text: 'Fotogr.', value: 'photographer' },
      { text: 'Creado', value: 'createdOn' },
      {
        text: 'Acciones',
        value: 'actions',
        align: 'center',
        sortable: false,
      },
    ]

    const searchQuery = ref('')
    const options = ref({
      sortBy: ['startDate'],
      sortDesc: [],
    })
    const totalItems = ref(0)
    const loading = ref(false)
    const isEditSidebarActive = ref(false)

    /** AddOns Dialog */
    const addAddOnsDialog = ref()

    /** Notes Add Dialog ********************* */
    const addNoteDialog = ref()

    /** Payments Add Dialog ****************** */
    const addPaymentDialog = ref()

    /** FulViewDialog* *********************** */
    const fullViewDialog = ref()

    /** Event Filter ************************* */

    const eventFilter = ref('')
    const eventSelect = ref()

    const SelectedEvent = value => {
      eventFilter.value = value
    }

    /** ****************************************** */
    /** EventStatus Filter ************************* */
    const selectedEventStatus = ref(null)
    const eventStatusSelect = ref()

    /** ****************************************** */
    /** PaymentStatus Filter ************************* */
    const selectedPaymentStatus = ref(null)
    const paymentStatusSelect = ref()

    /** ****************************************** */
    /** DateRange Filter ************************* */
    const lastYear = daysFromToday(-365).toISOString().split('T')[0]
    const nextWeek = daysFromToday(365).toISOString().split('T')[0]
    const defaultFromDate = ref(lastYear)
    const defaultToDate = ref(nextWeek)
    const fromFilter = ref(lastYear)
    const toFilter = ref(nextWeek)
    const rangeDatePicker = ref()

    const SelectedFromFilter = value => {
      fromFilter.value = value
    }
    const SelectedToFilter = value => {
      toFilter.value = value
    }

    /** ****************************************** */

    const FetchItems = () => {
      loading.value = true
      store
        .dispatch('bookings/apiCall', {
          mode: 'select',
          request: {
            q: searchQuery.value,
            srt: options.value.sortBy,
            desc: options.value.sortDesc,
            pg: options.value.page - 1,
            ippg: options.value.itemsPerPage,
            all: process.env.VUE_APP_API_ALL,
            eventKey: eventFilter.value ?? '',
            eventStatus: selectedEventStatus.value ?? '',
            paymentStatus: selectedPaymentStatus.value ?? '',
            from: fromFilter.value,
            to: toFilter.value,
          },
        })
        .then(response => {
          if (response.success) {
            items.value = response.data.items
            totalItems.value = response.data.total
          }
        })
        .finally(() => {
          loading.value = false
        })
    }

    const Search = () => {
      options.value.page = 1
      FetchItems()
    }

    const ClearSearch = () => {
      options.value.page = 1
      searchQuery.value = ''
      eventSelect.value.Reset()
      eventStatusSelect.value.Reset()
      paymentStatusSelect.value.Reset()
      rangeDatePicker.value.Reset()
      FetchItems()
    }

    watch([options], () => {
      FetchItems()
    })

    const prevKey = ref('')
    onMounted(() => {
      document.onkeydown = keyDownEvent => {
        if (keyDownEvent.key === 'Delete' && prevKey.value === 'Control') {
          ClearSearch()
          setTimeout(() => { FetchItems() }, 500)
        }
        prevKey.value = keyDownEvent.key
      }
    })

    onUnmounted(() => {
      document.onkeydown = null
    })

    return {
      active,
      activeColor,
      headers,
      searchQuery,
      options,
      totalItems,
      items,
      loading,
      isEditSidebarActive,
      bookingsEdit,
      FetchItems,
      ShowEditDialog,
      Search,
      ClearSearch,

      /** AddOns Dialog */
      addAddOnsDialog,

      /** Notes Add Dialog */
      addNoteDialog,

      /** Payments Add Dialog */
      addPaymentDialog,

      /** FullViewDialog */
      fullViewDialog,

      /** Event */
      eventSelect,
      SelectedEvent,

      /** EventStatus */
      eventStatusSelect,
      selectedEventStatus,

      /** PaymentStatus */
      paymentStatusSelect,
      selectedPaymentStatus,

      /** DateFilter */
      rangeDatePicker,
      defaultFromDate,
      defaultToDate,
      SelectedFromFilter,
      SelectedToFilter,

      /** Icons */
      icons: {
        mdiDeleteOutline,
        mdiEye,
        mdiMagnify,
        mdiBackspaceOutline,
        mdiPencilOutline,
        mdiCashRegister,
        mdiNotePlusOutline,
        mdiCartPlus,
      },
    }
  },
}
</script>
